import styled from '@emotion/styled';
import { Tooltip } from '@mui/material';
import Icons from '@shared/components/core/images/Icons';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { MacroDisplayModel } from '../../models/deviceProfiles/MacroModel';
import MacroStepIcons from './MacroStepIcons';
interface MacroPreviewIconsProps {
    macro: MacroDisplayModel;
}

// TODO: mave OverflowView a component shared with MacroStepIcons possibly unify with getOtherView

const MacroPreviewIcons: React.FC<MacroPreviewIconsProps> = ({ macro }) => {
    const { t } = useTranslation();
    const getOverflowView = () => {
        return (
            <Tooltip title={t('common:event.expand')}>
                <SingleStepContainer>
                    <Icons name="layers" />
                </SingleStepContainer>
            </Tooltip>
        );
    };

    return (
        <IconContainerView>
            {macro?.events?.slice(0, 2).map((event, index) => (
                <Fragment key={index}>
                    <MacroStepIcons event={event} />
                </Fragment>
            ))}
            {macro?.events?.length > 2 && getOverflowView()}
        </IconContainerView>
    );
};

const SingleStepContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

const IconContainerView = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    position: absolute;
    right: 24px;
    left: auto;

    img {
        width: 32px;
        margin: 0 2px;
    }
`;

export default MacroPreviewIcons;
